// src/components/MemberFaqs.js
import React from "react";

const FAQ_ITEM_STYLE = {
  background: "#fafafa",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  padding: "20px 24px",
};
const QUESTION_STYLE = { fontWeight: "600", margin: "0 0 8px 0", color: "#1F2937", fontSize: "1.05rem" };
const ANSWER_STYLE = { margin: 0, color: "#4B5563", lineHeight: "1.6", fontSize: "1.05rem" };

/**
 * The subscriber-facing FAQ block, shown on both Edit Profile and My
 * Events so members see the same answers wherever they land. `children`
 * (if given) renders as an extra item in the same list/box, styled to
 * match - EditProfile uses this for its "Manage Account" button.
 */
const MemberFaqs = ({ children }) => (
  <div style={{ marginBottom: "32px" }}>
    <h4 style={{ textAlign: "center", marginBottom: "16px", fontSize: "1.25rem" }}>FAQs</h4>
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <div style={FAQ_ITEM_STYLE}>
        <p style={QUESTION_STYLE}>How do I join a gathering?</p>
        <p style={ANSWER_STYLE}>
          Use the "Browse Gatherings" button above to see our event series, pick the one you're interested in, and choose an upcoming date. It only takes a minute to book your spot.
        </p>
      </div>
      <div style={FAQ_ITEM_STYLE}>
        <p style={QUESTION_STYLE}>What do I do when I arrive? How do I get my 20% off food and drinks?</p>
        <p style={ANSWER_STYLE}>
          Just show up at the venue and show this page at the bar - that's how you get 20% off food and drinks.
        </p>
      </div>
      <div style={FAQ_ITEM_STYLE}>
        <p style={QUESTION_STYLE}>Is there a host?</p>
        <p style={ANSWER_STYLE}>
          The gatherings are generally self-hosted with support from the venue. So there isn't a designated "host", but the venue staff will direct you to the booked area (view the event description for details about this). This helps us to keep the membership much more affordable.
        </p>
      </div>
      <div style={FAQ_ITEM_STYLE}>
        <p style={QUESTION_STYLE}>Why is there a subscription fee?</p>
        <p style={ANSWER_STYLE}>
          This ensures we can keep running the events to help you meet new people, and it helps us cover things such as marketing costs, time arranging with venues, customer support, and more. We plan to keep the fee as low as possible. Thanks for your support! 😊
        </p>
      </div>
      <div style={FAQ_ITEM_STYLE}>
        <p style={QUESTION_STYLE}>What if I have more questions?</p>
        <p style={ANSWER_STYLE}>
          Check your booking details on the Events page first, as most answers are there. If not, feel free to email us at <a href="mailto:info@okgather.com" style={{ color: "#8B5FBF" }}>info@okgather.com</a> and we aim to reply very quickly!
        </p>
      </div>
      {children}
    </div>
  </div>
);

export default MemberFaqs;
